var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationProvider", {
    attrs: { name: _vm.name, rules: _vm.mergedRules, slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var errors = ref.errors
          var failedRules = ref.failedRules
          return [
            _vm.showNumericOrFF
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.modifiedValue,
                      expression: "modifiedValue"
                    }
                  ],
                  class: _vm.getValidationErrorClasses(failedRules),
                  attrs: {
                    type: "number",
                    id: _vm.id,
                    "aria-labelledby": _vm.labelledBy ? _vm.labelledBy : null,
                    step: "1",
                    "aria-required": _vm.required && !_vm.isDisabled,
                    "aria-invalid":
                      _vm.required && !_vm.isDisabled && errors.length > 0,
                    "aria-label": _vm.$attrs["aria-label"],
                    readonly: _vm.isDisabled,
                    "aria-readonly": _vm.isDisabled,
                    placeholder: _vm.placeholder
                  },
                  domProps: { value: _vm.modifiedValue },
                  on: {
                    keydown: _vm.handleKeydown,
                    focus: _vm.focused,
                    blur: _vm.blurred,
                    wheel: _vm.preventWheel,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.modifiedValue = $event.target.value
                    }
                  }
                })
              : _c("input", {
                  class: _vm.getValidationErrorClasses(failedRules),
                  attrs: {
                    type: "text",
                    id: _vm.id,
                    "aria-labelledby": _vm.labelledBy ? _vm.labelledBy : null,
                    "aria-required": _vm.required && !_vm.isDisabled,
                    "aria-invalid":
                      _vm.required && !_vm.isDisabled && errors.length > 0,
                    "aria-label": _vm.$attrs["aria-label"],
                    "aria-readonly": _vm.isDisabled,
                    disabled: _vm.isDisabled,
                    "aria-disabled": _vm.isDisabled,
                    placeholder: _vm.placeholder
                  },
                  domProps: { value: _vm.modifiedValueStr },
                  on: { focus: _vm.focused }
                })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }